import {api} from "../../common";


export const INFO_URL = {
	getInfo:`${api.withAPI}/api/admin/info`,
	createInfo:`${api.withAPI}/api/admin/info`,
	getInfoById: (id: string) => `${api.withAPI}/api/admin/info/${id}`,
	update_info: `${api.withAPI}/api/admin/info/`,
}